export default __webpack_public_path__ + "static/metal-b3e2a343d79341a9dc5216bbdbfeb9ee.jpg";